export const DEFAULT_IMAGE = {
  LISTING: "/assets/listing/default-listing-image.webp",
  CITY: "/assets/other/default-city.webp",
};
